import CustomerDetailPage from 'src/pages/CustomerDetail';
import { manualLookupsTabs } from 'src/pages/ManualLookup/ManualLookupsTabs';
import { FormikErrors } from 'formik';
import { DetailProducts } from 'src/frontend-common/dto/Types/ProductType';
import { ScoreDomain } from 'src/redux/services/score';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

export interface IGenericFormValues {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  ip: string;
  domain: ScoreDomain;
}

export const defaultGenericFormValues: IGenericFormValues = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  ip: '',
  domain: {
    value: '',
    country: '',
  },
};

export const fieldNameTranslator = (product: string) => {
  if (product === 'device') {
    return 'user_agent';
  }
  return product;
};

export const renderActiveTabContent = (activeTab: number, resolutionId: string, navigateTo: NavigateCallbackFn) => {
  const products = manualLookupsTabs.map((tab) => tab.product);
  const product = products[activeTab];
  if (!product) return null;

  return <CustomerDetailPage product={product} key={resolutionId} resolution_id={resolutionId} navigateTo={navigateTo} />;
};

export const singleFormProducts: DetailProducts[] = ['phone', 'email', 'ip', 'domain'];

interface ValidationValues {
  email: string;
  first_name: string;
  last_name: string;
  phone: string;
  ip: string;
  [key: string]: any; // To accommodate additional fields if necessary
}

export function isValidDomain(domain: string): boolean {
  const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/;
  return domainRegex.test(domain);
}

export const validateFields = (values: ValidationValues, fieldName?: string): FormikErrors<ValidationValues> => {
  const errors: FormikErrors<ValidationValues> = {};

  const requiredFields = ['email', 'first_name', 'last_name', 'phone', 'ip'];
  for (const field of requiredFields) {
    if ((values[field] && values[field].trim().length === 0) || (fieldName === field && !values[field])) {
      errors[field] = 'Required';
    }
  }
  // add error if domain.value does not contain a dot
  if (fieldName === 'domain' && (!values.domain || values.domain.value.trim().length === 0 || isValidDomain(values.domain.value) === false)) {
    errors.domain = 'Invalid domain';
  }

  return errors;
};
